import { useState, useEffect } from "react";
import { Guidebook } from "../types/guidebook";
import { paths, API_URL } from "../config/endpoints";
import { refreshToken, isTokenExpired } from "../services/authServices";

export const useReservationGuidebooks = (reservationUuid: string) => {
  const [guidebooks, setGuidebooks] = useState<Guidebook[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const apiUrl = `${API_URL}/${paths.guest}/${paths.reservations}/${reservationUuid}/${paths.guidebooks}`;

  useEffect(() => {
    const fetchGuidebooks = async () => {
      setLoading(true);
      setError(null);

      try {
        let token = localStorage.getItem("token");

        if (!token || isTokenExpired(token)) {
          token = await refreshToken();
        }

        const response = await fetch(apiUrl, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          if (response.status === 404) {
            throw new Error("No units found for this reservation");
          } else if (response.status === 401) {
            throw new Error("Unauthorized: Invalid authentication credentials");
          } else if (response.status === 403) {
            throw new Error("Forbidden: You don't have access to this reservation");
          } else {
            throw new Error("Failed to fetch guidebooks");
          }
        }

        const data = await response.json();
        setGuidebooks(data);
      } catch (error: any) {
        setError(
          error.message || "An error occurred while fetching guidebooks"
        );
        // Handle token refresh errors
        if (error.message === "Failed to refresh token") {
          // Optionally redirect to login or notify the user
        }
      } finally {
        setLoading(false);
      }
    };

    // Fetch guidebooks if reservationUuid is provided
    if (reservationUuid) {
      fetchGuidebooks();
    }
  }, [reservationUuid, apiUrl]);

  return { guidebooks, loading, error };
};